import axios from 'axios'
const URL = process.env.REACT_APP_DOBBY_URL

export async function uploadLogoFavToS3(fileContents, type) {
  const presignedPostUrl = await getLogoFavSignedUrl('post', type)
  const SignedURL = presignedPostUrl.data.signed_url

  if (SignedURL) {
    const response = await axios.put(SignedURL, fileContents)

    let responseObj = {
      success: false,
      message: '',
      data: [],
    }

    if (response.status === 200) {
      responseObj = {
        success: true,
        message: 'Uploaded Succesfully!!',
      }
    } else {
      responseObj = {
        success: false,
        message: 'Failed!!',
        data: [],
      }
    }
    return responseObj
  }
}

async function getLogoFavSignedUrl(method, type) {
  try {
    const signedPostUrl = await axios({
      method: method,
      url: `${URL}/${type}`,
    })
    return signedPostUrl.data
  } catch (error) {
    console.log('Error')
    return error.data
  }
}
